function PopupHome() {
	this.build();
	barbaCallbacks.push(this);
}

PopupHome.prototype.build = function(){
	if (!document.body.classList.contains('home')) {
		return;
	}
    if (!document.querySelector('popup-blob')) {
        return;
    }

	let popupFiredDate = localStorage.getItem('popupFiredDate');
	let timestampCurrent = new Date().getTime();

    console.log( popupFiredDate, timestampCurrent );

	if ( popupFiredDate ) {
		let timeOffset = timestampCurrent - popupFiredDate;
		if (timeOffset < 3600000) {
			return;
		}
	}

	setTimeout( function() {
		document.body.classList.add('popup-is-shown');
		localStorage.setItem('popupFiredDate', timestampCurrent);

		document.querySelector('.popup-blob__close').addEventListener('click', function() {
			document.body.classList.remove('popup-is-shown');
		});
	}, 3000 );
};